import * as MD from '@material-ui/core';
import { SvgIcon } from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { NotificationBar } from '../Components/NotificationBarComponent';
import { SendResetPassword } from '../Components/Password/ResetPasswordComponent';
import { IApplicationState, IConnectedReduxProps } from '../Store';
import { I18N } from '../Store/I18n/Types';
import { ILayoutState } from '../Store/Layout/Types';
import { INotificationBarState } from '../Store/NotificationBar/Types';
import { sendResetPasswordEmail } from '../Store/ResetPassword/Actions';
import { IResetPasswordState } from '../Store/ResetPassword/Types';
import { getTheme } from '../Themes';
import { YacastLogoIcon } from '../Themes/svg/yacast-logo';

interface IPropsFromState {
	i18n: I18N;
	layout: ILayoutState;
	notificationBar: INotificationBarState;
	resetPassword: IResetPasswordState;
}

interface IPropsFromDispatch {
	sendResetPasswordEmail: typeof sendResetPasswordEmail;
}

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

const theme = getTheme();

const styles = MD.createStyles({
	button: {
		margin: theme.spacing(1),
		marginLeft: 0,
		marginRight: 0,
		textTransform: 'uppercase',
	},
	card: {
		maxWidth: '40%',
		minWidth: '20%',
		marginTop: '50px',
	},
	cardContent: {
		width: '100%',
	},
	errorContainer: {
		width: '100%',
		justifyContent: 'center',
		textAlign: 'center',
		color: 'red',
	},
	form: {
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'wrap',
	},
	media: {
		height: 140,
	},
});

export class ResetPasswordPage extends React.Component<AllProps> {
	public constructor(props: AllProps) {
		super(props);
	}

	public render(): React.ReactNode {
		const { classes, layout } = this.props;
		const theme = getTheme(layout.theme);

		return (
			<MD.Card className={classes.card}>
				<MD.CardActionArea></MD.CardActionArea>
				<MD.CardActions>
					<MD.CardContent className={classes.cardContent}>
						<MD.Typography
							gutterBottom={true}
							variant="h4"
							component="h2"
						>
							<SvgIcon
								component={YacastLogoIcon}
								htmlColor={theme.palette.text.primary}
							/>
						</MD.Typography>

						<MD.Typography
							variant="caption"
							color="textSecondary"
							component="p"
						></MD.Typography>
						<Route component={SendResetPassword} />
					</MD.CardContent>
				</MD.CardActions>

				<NotificationBar />
			</MD.Card>
		);
	}
}

const mapStateToProps = ({
	i18n,
	layout,
	notificationBar,
	resetPassword,
}: IApplicationState) => ({
	i18n: i18n.i18n,
	layout,
	notificationBar,
	resetPassword,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	sendResetPasswordEmail: (e: string, u: string) =>
		dispatch(sendResetPasswordEmail(e, u)),
});

export const ResetPassword = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withStyles(styles)(ResetPasswordPage));
